import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "spinner-border",
  role: "status"
}

import { useRouter } from "vue-router";
import { onMounted } from "vue";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";


const __default__ = {
  name: "AcceptInvitationView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter();

async function acceptInvite() {
  let inviteType = router.currentRoute.value.params["inviteType"] as string;
  let token = router.currentRoute.value.params["token"] as string;

  const functions = getFunctions();
  const acceptInviteCallable = httpsCallable(functions, "acceptInvite");
  await acceptInviteCallable({
    token: token,
    inviteType: inviteType,
  })
    .then(() => {
      // Refresh the user's token to ensure their role is acknowledged
      getAuth().currentUser?.getIdToken(true);
    })
    .then(() => {
      router.push("/");
    })
    .catch((error) => {
      console.log("Failed to accept invite", error);
    });
}

onMounted(() => {
  acceptInvite();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})